import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import InputField from './form/InputField';
import SafeIcon from '../common/SafeIcon';

const AMENITIES = [
  { id: '9901', name: 'BBQ A-1', price: '$300.000', type: 'fixed' },
  { id: '9902', name: 'BBQ A-2', price: '$300.000', type: 'fixed' },
  { id: '9903', name: 'BBQ A-3', price: '$300.000', type: 'fixed' },
  { id: '9904', name: 'BBQ B', price: '$240.000', type: 'fixed' },
  { id: '9905', name: 'Sala de Proyección 1', price: '$30.000/hora', type: 'time' },
  { id: '9906', name: 'Sala de Proyección 2', price: '$30.000/hora', type: 'time' },
  { id: '9907', name: 'Sala Juntas 1', price: '$5.000/hora', type: 'time' },
  { id: '9908', name: 'Sala Juntas 2', price: '$5.000/hora', type: 'time' },
  { id: '9909', name: 'Salón Social', price: '$340.000', type: 'fixed' },
  { id: '9910', name: 'Cancha de Fútbol', price: '$70.000/hora', type: 'time' },
  { id: '9911', name: 'Tarjeta de Acceso', price: '$25.000/unidad', type: 'unit' },
  { id: '9912', name: 'Piscina', price: 'Gratis', type: 'time' },
];

export default function AmenitiesView({ onBack, t }) {
  const [selectedId, setSelectedId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({ whatsapp: '', date: '', startTime: '', endTime: '' });

  const selectedAmenity = AMENITIES.find(a => a.id === selectedId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId || !formData.whatsapp) return;
    setIsSubmitting(true);
    try {
      const msg = `SOLICITUD AMENIDAD\nWhatsApp: ${formData.whatsapp}\nAmenidad: ${selectedAmenity.name}\nRef: ${selectedId}`;
      await fetch(`https://92afb.twidget.io/notify?msg=${encodeURIComponent(msg)}`, { method: 'POST' });
      setIsSubmitted(true);
    } catch (err) { console.error(err); } finally { setIsSubmitting(false); }
  };

  if (isSubmitted) {
    return (
      <div className="bg-white p-8 rounded-3xl shadow-xl text-center">
        <div className="w-20 h-20 bg-emerald-100 text-emerald-800 rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon name="Check" className="text-4xl" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">{t.amenitySuccess}</h2>
        <p className="text-gray-600 mb-8">{t.amenitySuccessMsg}</p>
        <button onClick={onBack} className="w-full bg-emerald-800 text-white font-bold py-4 rounded-2xl">
          {t.back}
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6 pb-20">
      <button onClick={onBack} className="flex items-center gap-2 text-gray-500 hover:text-emerald-800 font-medium">
        <SafeIcon name="ArrowLeft" /> {t.back}
      </button>

      <div className="bg-white p-6 md:p-8 rounded-3xl shadow-xl border border-gray-100">
        <h2 className="text-2xl font-bold mb-2">{t.amenitiesTitle}</h2>
        <p className="text-sm text-gray-500 mb-6 italic">{t.amenitiesSubtitle}</p>

        <div className="mb-8 p-4 bg-emerald-50 rounded-2xl border border-emerald-100">
          <InputField 
            label={t.whatsappRegistered} 
            name="whatsapp" 
            value={formData.whatsapp} 
            onChange={(e) => setFormData(p => ({ ...p, whatsapp: e.target.value }))} 
            required 
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          {AMENITIES.map((amenity) => (
            <button 
              key={amenity.id} 
              onClick={() => setSelectedId(amenity.id)} 
              className={`p-4 rounded-2xl border-2 text-left transition-all ${
                selectedId === amenity.id ? 'border-emerald-600 bg-emerald-50' : 'border-gray-100 bg-white'
              }`}
            >
              <div className="flex justify-between items-start mb-1">
                <span className="font-bold text-gray-900">{amenity.name}</span>
                <span className="text-[10px] bg-gray-100 px-2 py-0.5 rounded-full text-gray-500">{amenity.id}</span>
              </div>
              <p className="text-sm text-emerald-800 font-medium">
                {amenity.price === 'Gratis' ? t.free : amenity.price}
              </p>
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <AnimatePresence>
            {selectedAmenity && (selectedAmenity.type === 'time' || selectedAmenity.type === 'fixed') && (
              <motion.div 
                initial={{ opacity: 0, height: 0 }} 
                animate={{ opacity: 1, height: 'auto' }} 
                className="grid grid-cols-1 md:grid-cols-2 gap-4 border-t pt-6"
              >
                <div className="md:col-span-2">
                  <InputField 
                    label={t.amenityDate} 
                    name="date" 
                    type="date" 
                    value={formData.date} 
                    onChange={(e) => setFormData(p => ({ ...p, date: e.target.value }))} 
                    required 
                  />
                </div>
                <InputField 
                  label={t.startTime} 
                  name="startTime" 
                  type="time" 
                  value={formData.startTime} 
                  onChange={(e) => setFormData(p => ({ ...p, startTime: e.target.value }))} 
                  required 
                />
                <InputField 
                  label={t.endTime} 
                  name="endTime" 
                  type="time" 
                  value={formData.endTime} 
                  onChange={(e) => setFormData(p => ({ ...p, endTime: e.target.value }))} 
                  required 
                />
              </motion.div>
            )}
          </AnimatePresence>

          <button 
            type="submit" 
            disabled={isSubmitting || !selectedId || !formData.whatsapp} 
            className="w-full bg-emerald-800 text-white font-bold py-5 rounded-2xl shadow-xl flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? (
              <SafeIcon name="Loader" className="animate-spin" />
            ) : (
              <>
                <SafeIcon name="Send" /> {t.requestAmenity}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}